import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class BulkTaskTransitionRepositoryService extends BaseRepositoryService<
  ModelRegistry['bulk-task-transition']
> {
  recordName = 'bulk-task-transition';
  implementMethods = ['createRecord', 'save', 'unloadRecords'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/bulk-task-transition': BulkTaskTransitionRepositoryService;
  }
}
